export enum RMLicenseHttpStatusCode {
  UnknownViolation = 0,
  NoLicense = 440,
  InActive = 441,
  ExpiryViolation = 442,
  FeatureViolation = 443,
  SeatViolation = 444,
  ConcurrencyViolation = 445,
  SeatNotRegistered = 446,
  AnonymousError = 447,
  LicenseNotActive = 448,
  LicenseTerminated = 449,
  EditionViolation = 450,
  DBError = 451,
  LicenseUpdating = 453,
  LicenseNotification = 454,
}
